import objectPath from "object-path";
import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const REPORT_BY_GROUP = "REPORT_BY_GROUP";
export const REPORT_BY_GROUP_ERROR = "REPORT_BY_GROUP_ERROR";
export const REPORT_BY_GROUP_SUCCESS = "REPORT_BY_GROUP_SUCCESS";

/**
 * Reducer
 */

const initialState = {
  report: [],
  error: false,
  count: 0,
  loading: false,
};

export const reportGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case REPORT_BY_GROUP:
      return {
        ...state,
        loading: true,
      };
    case REPORT_BY_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload,
      };
    case REPORT_BY_GROUP_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    default:
      return state;
  }
};

/**
 * Action
 */
export const reportByGroup = (from, to) => ({
  type: REPORT_BY_GROUP,
  data: {
    from,
    to,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      reportByGroup,
    },
    dispatch
  );
};

/**
 * Apis
 */

const reportByGroupApi = (from, to) => {
  return apiCaller.getData(
    "/cloud-pbx/outbound-call/report-agent-peformance-by-team",
    { from, to }
  );
};

/**
 * sagas
 */

export const reportByGroupFlow = function* () {
  while (true) {
    const action = yield take(REPORT_BY_GROUP);
    try {
      const res = yield call(
        reportByGroupApi,
        action.data.from,
        action.data.to
      );
      const data = res.data.sort(function (a, b) {
        var n = new Date(b.date).getTime() - new Date(a.date).getTime();
        if (n != 0) {
          return n;
        }
        return a.agent.code - b.agent.code;
      });
      const reportGroups = {
        date: {
          fields: ["date"],
        },
        dateNTeam: {
          fields: ["date", "agentGroup.name"],
        },
      };
      data.forEach((item) => {
        item.groups = {};
        for (const groupName in reportGroups) {
          if (reportGroups.hasOwnProperty(groupName)) {
            const value = reportGroups[groupName];
            let foundItemsInGroup = data.filter((i) => {
              let reportGroup = reportGroups[groupName];
              let condition = true;
              if (reportGroup) {
                reportGroup.fields.forEach((field) => {
                  condition &=
                    objectPath.get(i, field) === objectPath.get(item, field);
                });
              }
              return condition;
            });
            let indexInGroup = foundItemsInGroup.indexOf(item);

            item.groups[groupName] = {
              index: indexInGroup,
              count: foundItemsInGroup.length,
            };
          }
        }
      });
      yield put({ type: REPORT_BY_GROUP_SUCCESS, payload: { ...data } });
    } catch (error) {
      yield put({ type: REPORT_BY_GROUP_ERROR, error });
    }
  }
};
